import React from 'react';
import { Typography, Grid, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import Clock from '../../../../../assets/img/reloj.jpg'

export default function Description() {
  return (
    <>
     <Grid container spacing={2}>
          <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <img
              src={Clock}
              alt="Descripción de la imagen"
              style={{ maxWidth: '500px', height: '300px', marginTop: '20px' }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1" align="left">
              <p style={{fontSize: '15px'}}>Para asegurar el correcto funcionamiento de un equipo informático es recomendable revisar su rendimiento periódicamente, tanto si es nuevo como si tiene varios años.</p>
              <p style={{fontSize: '15px'}}>El servicio de Revisión y Puesta a Punto permite evaluar, de forma automática, varios componentes del equipo que pueden afectar a su rendimiento, como por ejemplo, el disco duro, memoria virtual, archivos temporales, seguridad, etc.</p>
              <p style={{fontSize: '15px'}}>Una vez realizado el análisis, la aplicación genera un informe donde se detallan los resultados, así como recomendaciones; si el rendimiento no es óptimo nuestros técnicos le ayudarán a solucionar cualquier problema de manera inmediata.</p>
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Typography variant="body1" align="left">
              <h4>Como acceder</h4>
              <ol style={{paddingInlineStart: '20px'}}>
                <li>Para comenzar a utilizar este servicio, en primer lugar debe registrarse; el registro sólo debe realizarse la primera vez que acceda a alguno de los servicios contenidos en la solución.</li>
                <li>Una vez que se haya registrado, podrá acceder a todos los servicios. Seleccione en Acceda al servicio y comience a disfrutar del mismo.</li>
              </ol>
              <Box
                  component={Link}
                  to="/"
                  sx={{
                    display: 'inline-flex', // Asegura que los íconos y el texto se alineen correctamente
                    alignItems: 'center', // Centra el contenido del enlace verticalmente
                    bgcolor: 'red',
                    '&:hover': {
                      bgcolor: 'darkred',
                    },
                    color: 'white', // Establece el color del texto e ícono a blanco
                    textDecoration: 'none', // Remueve el subrayado del enlace
                    width: '50%', // O ajusta según sea necesario
                    justifyContent: 'center', // Centra el contenido horizontalmente si es necesario
                    padding: '6px 16px', // Ajusta el padding para igualar al del Button, si es necesario
                  }}
                >
                  Accede al sitio
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Typography variant="body1" align="left">
              <h4>Cómo usar</h4>
              <ol style={{paddingInlineStart: '20px'}}>
                <li>Una vez que haya accedido al servicio, podrá seleccionar “Revisión y Puesta a Punto.</li>
                <li>Para iniciar la revisión de su equipo seleccione “Iniciar análisis”; en pocos segundos podrá revisar el informe de estado.</li>
                <li>Si el resultado obtenido no es óptimo, podrá “Solicitar asistencia” a nuestros técnicos; el servicio se prestará a través del chat del servicio de Ayuda Tecnológica Online.</li>
              </ol>
            </Typography>
          </Grid>
        </Grid>
        </>
  );
}